export const downloadCsv = (data: any[]) => {
  const csv = exportToCsv(data);
  const csvData = addToBOM(csv);
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  window.open(url);
};

export const exportToCsv = (rows: any[]) => {
  if (!rows || !rows.length) {
    return;
  }
  const separator = ';';
  const keys = Object.keys(rows[0]);
  const csvData = `${keys.join(separator)
  }\n${
    rows.map((row) => keys.map((k) => {
      let cell = row[k] === null || row[k] === undefined ? '' : row[k];
      cell = cell instanceof Date
        ? cell.toLocaleString()
        : cell.toString().replace(/"/g, '""');
      if (cell.search(/("|,|\n)/g) >= 0) {
        cell = `"${cell}"`;
      }
      return cell;
    }).join(separator)).join('\n')}`;
  return csvData;
};

export const addToBOM = (csv?: string) => {
  const BOM = '\uFEFF';
  return BOM + csv;
}